'use client';
import React, { useId } from 'react';
import { UserAuth } from '@/app/context/AuthContext';
import { useRouter } from 'next/navigation';
import { FREE_HISTORY_LABEL } from '@/utils/paywall';

const BUTTON_CLASS =
	'rounded-lg bg-[#b232e5] px-8 py-3 text-base font-semibold text-white hover:bg-[#9a28c7] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#b232e5]';

// Shown after the last message the visitor's plan allows.
// Guest: sign in to see more. Free account: upgrade to Pro.
// `message` optionally replaces the free account's body line.
const PaywallCard = ({ message }) => {
	const { user, isPro, userLoading, authReady, googleSignIn } = UserAuth();
	const router = useRouter();
	// Unique per card so several on one page (Following) label themselves correctly.
	const headingId = useId();

	const handleSignIn = async () => {
		try {
			await googleSignIn();
		} catch (err) {
			console.error('Sign-in failed:', err);
		}
	};

	// Never flash the upsell at a pro member while their account is still loading.
	if (!authReady || (user && (isPro || userLoading))) return null;

	return (
		<section
			aria-labelledby={headingId}
			className='my-8 flex justify-center px-4'
		>
			<div className='w-full max-w-xl rounded-2xl bg-white p-6 md:p-8 shadow-lg text-center'>
				<h2
					id={headingId}
					className='text-2xl md:text-3xl font-bold text-black mb-3'
				>
					{user ? 'Unlock Full History' : 'Sign in to see more messages'}
				</h2>
				<p className='text-gray-500 text-base mb-6 max-w-md mx-auto'>
					{user
						? message || 'Get Pro to see all messages and follow your favorite brands.'
						: `Create a free account to unlock ${FREE_HISTORY_LABEL} of history.`}
				</p>
				{user ? (
					<button
						type='button'
						onClick={() => router.push('/pro')}
						aria-label='Get Pro'
						className={BUTTON_CLASS}
					>
						Get Pro
					</button>
				) : (
					<button
						type='button'
						onClick={handleSignIn}
						aria-label='Sign in with Google'
						className={BUTTON_CLASS}
					>
						Sign in with Google
					</button>
				)}
			</div>
		</section>
	);
};

export default PaywallCard;
